import type { ReactElement } from 'react'
import { Fragment } from 'react'
import { Navigate, Route } from 'react-router-dom'
import { AreaGate, InicioDaArea } from '../../core/areas/AreaGate'
import { FoiParaOAdministrativo, VoltouParaLogistica } from '../../core/areas/VoltouParaLogistica'
import { PermissionGate } from '../../core/router/guards'
import { CATEGORIAS_CONFIGS, CUSTOM_FORM_BASE_PATHS, cargosConfig, usuariosConfig } from '../../features/cadastros/configs'
import { AuditoriaPage, CategoriasHub, ResourceFormPage, ResourceListPage, UsuarioFormPage } from '../../core/router/telas'

/** Último segmento de um basePath ('/administrativo/categorias/fleet' → 'fleet'). */
const slug = (basePath: string) => basePath.split('/').filter(Boolean).pop() ?? basePath

/** As rotas da área Administrativo: Usuários, Cargos, Categorias e Auditoria. Cada
 *  tela segue com o portão da própria key: entrar na área não dá nenhuma delas a
 *  ninguém. */
export function rotasDoAdministrativo(): ReactElement {
  return (
    <>
      <Route path="/administrativo/cadastros/*" element={<VoltouParaLogistica />} />
      {/* As Categorias moraram na Logística de 26/10 a 04/11/2026. */}
      <Route path="/logistica/categorias/*" element={<FoiParaOAdministrativo />} />
      <Route path="/administrativo" element={<AreaGate area="administrativo" />}>
        <Route index element={<InicioDaArea area="administrativo" />} />

        {/* Usuários: a lista no config; o criar e editar têm seis abas de vinculação,
            que não cabem na casca genérica de cartão único. */}
        <Route path="/administrativo/usuarios" element={<PermissionGate permission="users.view"><ResourceListPage config={usuariosConfig} /></PermissionGate>} />
        <Route path="/administrativo/usuarios/new" element={<PermissionGate permission="users.view"><UsuarioFormPage variante="backoffice" /></PermissionGate>} />
        <Route path="/administrativo/usuarios/:uuid" element={<PermissionGate permission="users.view"><UsuarioFormPage variante="backoffice" /></PermissionGate>} />

        {/* Cargos: o conjunto de áreas e permissões que o usuário herda. */}
        <Route path="/administrativo/cargos" element={<PermissionGate permission="users.view"><ResourceListPage config={cargosConfig} /></PermissionGate>} />
        <Route path={`${cargosConfig.basePath}/new`} element={<PermissionGate permission="users.view"><ResourceFormPage config={cargosConfig} /></PermissionGate>} />
        <Route path={`${cargosConfig.basePath}/:uuid`} element={<PermissionGate permission="users.view"><ResourceFormPage config={cargosConfig} /></PermissionGate>} />

        {/* Hub CATEGORIAS: os catálogos de tipo e classificação e os Status, no
            Administrativo desde 04/11/2026 (Samuel). Default = Frota. */}
        <Route path="/administrativo/categorias" element={<PermissionGate permission="master_data.view"><CategoriasHub /></PermissionGate>}>
          <Route index element={<Navigate to="fleet" replace />} />
          {CATEGORIAS_CONFIGS.map((cfg) => (
            <Route key={cfg.basePath} path={slug(cfg.basePath)} element={<ResourceListPage config={cfg} />} />
          ))}
        </Route>
        {CATEGORIAS_CONFIGS
          .filter((cfg) => !CUSTOM_FORM_BASE_PATHS.has(cfg.basePath) && !cfg.readOnly)
          .map((cfg) => (
            <Fragment key={`form-${cfg.basePath}`}>
              <Route path={`${cfg.basePath}/new`} element={<PermissionGate permission="master_data.view"><ResourceFormPage config={cfg} /></PermissionGate>} />
              <Route path={`${cfg.basePath}/:uuid`} element={<PermissionGate permission="master_data.view"><ResourceFormPage config={cfg} /></PermissionGate>} />
            </Fragment>
          ))}

        <Route path="/administrativo/auditoria" element={<PermissionGate permission="audit.view"><AuditoriaPage /></PermissionGate>} />
      </Route>
    </>
  )
}
